import { render, staticRenderFns } from "./PasswordErrors.vue?vue&type=template&id=6a209933"
import script from "./PasswordErrors.vue?vue&type=script&lang=ts"
export * from "./PasswordErrors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports